<app-dashboard-block-layout [label]="label" [labelIcon]="labelIcon">
  <ul class="p-reset" *ngIf="items?.length; else emptyTemplate">
    <li [class.mb-2]="i < items.length - 1" *ngFor="let item of items; index as i">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
    </li>
  </ul>
</app-dashboard-block-layout>
